import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export function DomainRolloutCard({ onSaved }) {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/domains/settings").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const save = async (next) => {
    let confirm = false;
    if (next.enabled_for_all && !s.enabled_for_all) {
      if (!window.confirm("Enable custom domains for ALL customers?\n\nOnly do this after the real domain test on the VPS has passed.")) return;
      confirm = true;
    }
    setBusy(true);
    try { const { data } = await api.put("/admin/domains/settings", { ...next, confirm }); setS({ ...s, ...data }); toast.success("Custom domain settings saved"); onSaved?.(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const cur = { enabled_for_all: s.enabled_for_all, pilot_company_id: s.pilot_company_id, ops_email: s.ops_email };
  const t = s.thresholds;
  const locked = busy || !s.can_edit;
  return (
    <div className="rounded-2xl border border-border bg-card p-5 mb-5 space-y-4" data-testid="domain-rollout-card">
      <div className="flex flex-wrap items-center gap-3">
        <b>Customer access</b>
        <span data-testid="domain-rollout-state" className={`text-xs font-bold rounded-full px-2.5 py-1 ${s.enabled_for_all ? "bg-emerald-500/10 text-emerald-600" : "bg-amber-500/10 text-amber-600"}`}>{s.enabled_for_all ? "On for all customers" : s.pilot_company_id ? "Pilot company only" : "Off for everyone"}</span>
        <label className="ml-auto flex items-center gap-2 text-sm"><input type="checkbox" data-testid="domain-rollout-all" disabled={locked} checked={s.enabled_for_all} onChange={(e) => save({ ...cur, enabled_for_all: e.target.checked })} />Enable for all customers</label>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <label className="text-xs font-semibold text-muted-foreground">Pilot company (can use custom domains while off for everyone)
          <select data-testid="domain-pilot-select" disabled={locked} value={s.pilot_company_id || ""} onChange={(e) => save({ ...cur, pilot_company_id: e.target.value || null })} className="mt-1 w-full rounded-lg border border-input bg-background px-2 py-2 text-sm text-foreground">
            <option value="">No pilot company</option>
            {s.companies.map((c) => <option key={c.id} value={c.id}>{c.name || c.id} ({c.plan || "basic"})</option>)}
          </select></label>
        <OpsEmail value={s.ops_email} busy={locked} onSave={(ops_email) => save({ ...cur, ops_email })} />
      </div>
      {!s.can_edit && <p className="text-xs text-amber-600" data-testid="domain-rollout-owner-only">Only the platform owner can change these settings.</p>}
      <p className="text-xs text-muted-foreground">Health alerts go to the company owner and the operations email: DNS missing in {t.dns_failed_checks} checks in a row, certificate renewal failing {t.renew_failures} times, or certificate expiring within {t.expiry_days} days. One email per problem, plus a recovery email.</p>
    </div>
  );
}

function OpsEmail({ value, busy, onSave }) {
  const [v, setV] = useState(value || "");
  return (
    <label className="text-xs font-semibold text-muted-foreground">Operations alert email (empty = all Super Admins)
      <div className="flex gap-2 mt-1">
        <input data-testid="domain-ops-email" value={v} onChange={(e) => setV(e.target.value)} placeholder="ops@qrcodecreatorstudio.com" className="flex-1 rounded-lg border border-input bg-background px-2 py-2 text-sm text-foreground" />
        <button data-testid="domain-ops-email-save" disabled={busy || v === (value || "")} onClick={() => onSave(v.trim())} className="rounded-lg bg-primary text-primary-foreground px-3 text-sm font-bold disabled:opacity-50">Save</button>
      </div>
    </label>
  );
}
